import { Controller } from "stimulus"

export default class extends Controller {
    static targets = [ "loadingBar", "row", "modal", "modalContent" ]
        
    initialize() {
      this.hitCounter = 0
      this.switchTracker = true
      this.modalOpen = false
      this.modalRequestId = 0
    }

    connect() {
      console.log("Events scroll controller!")
      this.handlePopState = this.handlePopState.bind(this)
      this.handleKeydown = this.handleKeydown.bind(this)
      window.addEventListener("popstate", this.handlePopState)
      window.addEventListener("keydown", this.handleKeydown)
    }

    disconnect() {
      window.removeEventListener("popstate", this.handlePopState)
      window.removeEventListener("keydown", this.handleKeydown)
    }

    scroll(event) {
      const scrolLevel = this.element.scrollTop / (this.element.scrollHeight - this.element.clientHeight)
      if(scrolLevel > 0.8 && this.switchTracker) {
        this.switchTracker = false
        this.hitCounter += 1

        this.loadingBarTarget.classList.remove("d-none")
        const url = `/events?filter=previous&counter=${this.hitCounter}`

        //let url = window.location.href
        // let url = `${this.element.dataset.searchQuery}&counter=${this.hitCounter}` 
        fetch(url, { headers: { "Accept": "text/plain", "X-Requested-With": "XMLHttpRequest" }})
        .then(response => {
          if (!response.ok) throw new Error(`Events request failed with ${response.status}`)
          return response.text()
        })
        .then((data) => {
          if (!this.isValidEventsMarkup(data)) throw new Error("Events request did not return event cards")

          this.loadingBarTarget.classList.add("d-none")
          this.rowTarget.insertAdjacentHTML("beforeend", data)
          this.switchTracker = data.trim() !== ""
        })
        .catch((error) => {
          console.error(error)
          this.hitCounter -= 1
          this.loadingBarTarget.classList.add("d-none")
          this.switchTracker = true
        })
      }
    }

    openEventModal(event) {
      if (this.shouldAllowNativeNavigation(event)) return

      event.preventDefault()

      const link = event.currentTarget
      const url = link.href

      if (!url || !this.hasModalTarget || !this.hasModalContentTarget) {
        window.location.href = url
        return
      }

      const requestId = ++this.modalRequestId
      this.setLoadingState()
      this.showModal()

      return fetch(url, { headers: { "Accept": "text/html", "X-Requested-With": "XMLHttpRequest" }})
        .then(response => {
          if (!response.ok) throw new Error(`Event page request failed with ${response.status}`)
          return response.text()
        })
        .then((html) => {
          if (requestId !== this.modalRequestId || !this.modalOpen) return

          const parser = new DOMParser()
          const doc = parser.parseFromString(html, "text/html")
          const eventShow = doc.querySelector(".box-event-show")

          if (!eventShow) {
            window.location.href = url
            return
          }

          this.modalContentTarget.innerHTML = eventShow.outerHTML
          this.prepareModalContent()
          this.modalTarget.classList.remove("is-loading")
          this.modalContentTarget.removeAttribute("aria-busy")
        })
        .catch(() => {
          if (requestId !== this.modalRequestId || !this.modalOpen) return

          window.location.href = url
        })
    }

    closeModal(event) {
      if (event) event.preventDefault()

      this.hideModal()
    }

    closeModalFromBackdrop(event) {
      if (event.target === this.modalTarget) this.closeModal(event)
    }

    handlePopState() {
      if (this.modalOpen) {
        this.hideModal()
      }
    }

    handleKeydown(event) {
      if (this.modalOpen && event.key === "Escape") {
        this.closeModal(event)
      }
    }

    scrollToPrevious() {
      const previousSection = document.getElementById('previous-section');
      if (previousSection) {
        previousSection.scrollIntoView({ behavior: 'smooth' });
      }
    }

    shouldAllowNativeNavigation(event) {
      return event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
    }

    isValidEventsMarkup(data) {
      const trimmedData = data.trim()
      return trimmedData === "" ||
        (
          !trimmedData.startsWith("<!DOCTYPE") &&
          !trimmedData.startsWith("<html") &&
          !trimmedData.includes("We're sorry, but something went wrong")
        )
    }

    showModal() {
      this.modalOpen = true
      this.modalTarget.classList.remove("d-none")
      document.body.classList.add("event-index-modal-open")
    }

    hideModal() {
      if (!this.hasModalTarget || !this.hasModalContentTarget) return

      this.modalOpen = false
      this.modalRequestId += 1
      this.modalTarget.classList.add("d-none")
      this.modalContentTarget.innerHTML = ""
      document.body.classList.remove("event-index-modal-open")
    }

    setLoadingState() {
      this.modalTarget.classList.add("is-loading")
      this.modalContentTarget.setAttribute("aria-busy", "true")
      this.modalContentTarget.innerHTML = `
        <div class="event-index-modal-loading">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading event details</span>
          </div>
        </div>
      `
    }

    prepareModalContent() {
      const showBox = this.modalContentTarget.querySelector(".box-event-show")
      if (showBox) {
        showBox.classList.add("event-index-modal-show")
      }
    }

}
